import React from 'react'
import { useTranslation } from 'react-i18next'
import { styled, Box, Button } from '@mui/material'
import { Snackbar as SnackbarUnstyled } from '@mui/base/Snackbar'

import { useNavigate } from 'router'
import { TYPOLOGIES } from 'pages/Auth/Demo'

const StyledSnackbar = styled(SnackbarUnstyled)(({ theme }) => {
  return `
    display: flex;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    align-items: center;
    gap: ${theme.spacing(2)};
    background: #292929;
    font-size: 10px;
    font-weight: 400;
    border-radius: 12px;
    padding: 8px 8px 8px 16px;
    box-shadow: 0px 12px 24px -8px rgba(0, 0, 0, 0.40);
    z-index: 10000;
    pointer-events: none;
    height: 40px;
    justify-content: space-between;
    max-height: 40px;
    min-height: 40px;
`
})

const StyledButton = styled(Button)(() => {
  return `
    background-color: #DBE8FE;
    color: #2570EB;
    border-radius: 6px;
    padding: 0 16px;
    font-size: 10px;
    font-weight: 500;
    height: 24px;
    max-height: 24px;
    min-height: 24px;
    text-transform: none;
    pointer-events: auto;
    min-width: auto;
    flex-shrink: 0;
    line-height: 1;
    &:hover {
      background-color: #C5D7FD;
    }
    &.MuiButton-root {
      height: 24px;
      max-height: 24px;
      min-height: 24px;
    }
  `
})

const FooterSimulation = ({ user }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  if (!(user?.fake || user?.demo_mode)) {
    return null
  }

  const handleLogout = () => {
    if (user.fake) {
      navigate({ pathname: '/auth/fakeout' })
    } else {
      navigate({ pathname: '/auth/exit_demo_mode' })
    }
  }

  const icon = user.demo_mode
    ? TYPOLOGIES.find(({name}) => user.demo_mode === name)?.icon
    : 'masks-theater'

  const displayName = user.first_name && user.last_name 
    ? `${user.first_name} ${user.last_name}` 
    : user.name || user.email

  return (
    <StyledSnackbar horizontal="center" open={true}>
      <Box display="flex" alignItems="center" gap={2}>
        <i className={`fa-light fa-${icon}`} style={{ fontSize: '18px' }} />
        {user.fake ? (
          <Box>
            {t('auth.fake_simulation_info_name')} <span style={{ fontWeight: 600 }}>{displayName}</span>{' '}
            {t('auth.fake_simulation_info_email', { email: user.email })}
          </Box>
        ) : (
          <>
            {t('demo.footer_info')} <span style={{ fontWeight: 600 }}>{t(`demo.topology.${user.demo_mode}`)}</span>{' '}
          </>
        )}
      </Box>
      <StyledButton onClick={handleLogout}>
        {user.fake ? t('auth.exit_simulation') : t('demo.footer_exit')}
      </StyledButton>
    </StyledSnackbar>
  )
}

export default FooterSimulation
